<div class="bb-player" [style.opacity]="playerOpacity">
	<div *ngIf="!hasValidAssets">
		<bb-warning [contents]="'NO_VALID_ASSETS' | translate" ></bb-warning>
		<p>{{ 'NO_PREVIEW_AVAILABLE' | translate }}</p>
	</div>
	<div [hidden]="!hasValidAssets" class="player-wrapper" [ngClass]="{'loading': loadingNewClip, 'black': !transparentBackground}" #playerWrapper [ngStyle]="{'min-height.px': inheritDimensions ? null : minHeight}"></div>
</div>
